export default {
  TopImpressionRatePercent: 'TopImpressionRatePercent',
  AbsoluteTopImpressionRatePercent: 'AbsoluteTopImpressionRatePercent',
  TopImpressionShareLostToRankPercent: 'TopImpressionShareLostToRankPercent',
  TopImpressionShareLostToBudgetPercent: 'TopImpressionShareLostToBudgetPercent',
  AbsoluteTopImpressionShareLostToRankPercent: 'AbsoluteTopImpressionShareLostToRankPercent',
  AbsoluteTopImpressionShareLostToBudgetPercent: 'AbsoluteTopImpressionShareLostToBudgetPercent',
};
